import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';

const EditTravelList = () => {
    const [clothes, setClothes] = useState([]); // Store available clothes
    const [formData, setFormData] = useState({
        list_name: '',
        destination: '',
        description: '',
        departure_date: '',
        return_date: '',
        clothing_items: []
    });

    // Search state variables
    const [clothNameSearchTerm, setClothNameSearchTerm] = useState('');
    const [categorySearchTerm, setCategorySearchTerm] = useState('');
    const [colorSearchTerm, setColorSearchTerm] = useState('');
    const [seasonSearchTerm, setSeasonSearchTerm] = useState('');

    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        fetchTravelList(); // Load travel list data
        fetchClothes(); // Load clothes data
    }, []);

    const fetchTravelList = async () => {
        try {
            const response = await axios.get(`http://localhost:3000/api/travellists/${id}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            const travelList = response.data;
            setFormData({
                list_name: travelList.list_name,
                destination: travelList.destination.join(', '),
                description: travelList.description,
                departure_date: travelList.departure_date ? travelList.departure_date.split('T')[0] : '',
                return_date: travelList.return_date ? travelList.return_date.split('T')[0] : '',
                clothing_items: travelList.clothing_items.map(item => item._id)
            });
        } catch (error) {
            console.error('Error fetching travel list:', error.response ? error.response.data : error.message);
        }
    };

    const fetchClothes = async () => {
        try {
            const response = await axios.get('http://localhost:3000/api/clothes', {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            setClothes(response.data);
        } catch (error) {
            console.error('Error fetching clothes:', error.response ? error.response.data : error.message);
        }
    };

    const handleClothSelect = (clothId) => {
        setFormData(prevData => ({
            ...prevData,
            clothing_items: prevData.clothing_items.includes(clothId)
                ? prevData.clothing_items.filter(id => id !== clothId)
                : [...prevData.clothing_items, clothId]
        }));
    };

    const isSelected = (clothId) => formData.clothing_items.includes(clothId);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const updatedTravelList = {
            list_name: formData.list_name,
            destination: formData.destination.split(',').map(des => des.trim()),
            description: formData.description,
            departure_date: formData.departure_date,
            return_date: formData.return_date,
            clothing_items: formData.clothing_items
        };

        try {
            await axios.put(`http://localhost:3000/api/travellists/${id}`, updatedTravelList, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            navigate('/travellists');  // Redirect to Travel Lists page after update
        } catch (error) {
            console.error('Error updating travel list:', error.response ? error.response.data : error.message);
            alert('Error updating travel list. Please try again.');
        }
    };

    // Filter clothes based on search terms
    const filteredClothes = clothes.filter(cloth => {
        const matchesClothName = cloth.cloth_name.toLowerCase().includes(clothNameSearchTerm.toLowerCase());
        const matchesCategory = cloth.category.some(cat => cat.toLowerCase().includes(categorySearchTerm.toLowerCase()));
        const matchesColor = cloth.color.some(col => col.toLowerCase().includes(colorSearchTerm.toLowerCase()));
        const matchesSeason = cloth.season.some(sea => sea.toLowerCase().includes(seasonSearchTerm.toLowerCase()));

        return matchesClothName && matchesCategory && matchesColor && matchesSeason;
    });

    return (
        <div className="edit-travelList-container">
            <h2><strong>𝐸𝒹𝒾𝓉 𝒯𝓇𝒶𝓋𝑒𝓁 𝐿𝒾𝓈𝓉</strong></h2>
            <form onSubmit={handleSubmit}>
                <label>
                    <strong>Name:</strong>
                    <input
                        type="text"
                        name="list_name"
                        value={formData.list_name}
                        onChange={handleChange}
                        placeholder="Enter travel list name"
                    />
                </label>
                <label>
                    <strong>Destination\-s:</strong>
                    <input
                        type="text"
                        name="destination"
                        value={formData.destination}
                        onChange={handleChange}
                        placeholder="e.g. Greece, Corfu (separate with commas)"
                    />
                </label>
                <label>
                    <strong>Departure Date:</strong>
                    <input
                        type="date"
                        name="departure_date"
                        value={formData.departure_date}
                        onChange={handleChange}
                    />
                </label>
                <label>
                    <strong>Return Date:</strong>
                    <input
                        type="date"
                        name="return_date"
                        value={formData.return_date}
                        onChange={handleChange}
                    />
                </label>
                <label>
                    <strong>Description:</strong>
                    <input
                        type="text"
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        placeholder="Describe your travel purpose (optional)"
                    />
                </label>
                <div className="search-filters">
                    <h3><strong>𝒮𝑒𝒶𝓇𝒸𝒽 & 𝒮𝑒𝓁𝑒𝒸𝓉 𝒞𝓁𝑜𝓉𝒽𝑒𝓈:</strong></h3>
                    <input
                        type="text"
                        placeholder="Search by cloth name"
                        value={clothNameSearchTerm}
                        onChange={(e) => setClothNameSearchTerm(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Search by category"
                        value={categorySearchTerm}
                        onChange={(e) => setCategorySearchTerm(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Search by color"
                        value={colorSearchTerm}
                        onChange={(e) => setColorSearchTerm(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Search by season"
                        value={seasonSearchTerm}
                        onChange={(e) => setSeasonSearchTerm(e.target.value)}
                    />
                </div>
                <div className="clothing-list">
                    {filteredClothes.map((cloth) => (
                        <div key={cloth._id} 
                            className={`clothing-item ${isSelected(cloth._id) ? 'selected' : ''}`}
                            onClick={() => handleClothSelect(cloth._id)}>
                            <img crossorigin="anonymous" src={`http://localhost:3000/${cloth.image_url}`} alt={cloth.cloth_name} />
                            <label>{cloth.cloth_name}</label>
                        </div>
                    ))}
                </div>
                <button type="submit"><i class="fa-solid fa-upload"></i> <strong>𝒰𝓅𝒹𝒶𝓉𝑒</strong></button>
            </form>
        </div>
    );
};

export default EditTravelList;